import { useArticlesSearchProvider } from '@obeta/data/lib/hooks/useArticleSearchProvider'
import { Typography } from '@mui/material'
import { ShopLink } from '@obeta/components/lib/link/ShopLink'
import styles from './ExactSearch.module.scss'
import { buildSearchUrlWithSearchString } from '@obeta/utils/lib/search/buildSearchUrlWithSearchString'
import { useTranslation } from 'react-i18next'

export const ExactSearch = () => {
  const { t } = useTranslation()
  const { smartQuery } = useArticlesSearchProvider()

  if (!smartQuery || smartQuery.searchQuery === smartQuery.userQuery) return null

  return (
    <div>
      <Typography variant="body">{t('SEARCH.EXACT_SEARCH_LABEL')}</Typography>{' '}
      <ShopLink
        href={buildSearchUrlWithSearchString(smartQuery.userQuery, true)}
        className={styles.link}
        data-test-id="exactSearchLink"
      >
        {smartQuery.userQuery}
      </ShopLink>
    </div>
  )
}
